import React, { Fragment, useState } from 'react';
import { Col, Media, Nav, NavLink } from 'reactstrap';
import { H6, Image, P } from '../../../AbstractElements';
import SearchNotFoundClass from './SearchNotFoundClass';

const ListNewContact = ({ users, userCallback }) => {
  var images = require.context('./../../../assets/images/', true);
  const [dynamictab, setDynamicTab] = useState('0');

  const ContactDetails = (user) => {
    userCallback({ id: user.id, name: user.name, surname: user.surname, email: user.email, avatar: user.avatar, age: user.age, mobile: user.mobile });
  };

  const dynamicImage = (image) => {
    return images(`./${image || "user.png"}`);
  };

  return (
    <Fragment>
      <Col xl="4" md="5" className='xl-50'>
        <Nav className="flex-column nav-pills">
          {users ?
            users.map((user, index) => {
              return (
                <NavLink className={dynamictab === index ? 'active' : ''} onClick={() => setDynamicTab(index)} key={index} >
                  <Media onClick={() => ContactDetails(user)}>
                   <Image attrImage={{ className: 'p-0 img-fluid img-50 m-r-20 rounded-circle update_img_0', src: `${dynamicImage(user.avatar)}`, alt: '' }} />
                    <Media body>
                      <H6>
                        <span className="first_name_0">{user.name}</span>
                        <span className="last_name_0">{user.surname}</span>
                      </H6>
                      <P attrPara={{ className: 'email_add_0' }}>{user.email}</P>
                    </Media>
                  </Media>
                </NavLink>
              );
            })
            :
            <SearchNotFoundClass />
          }
        </Nav>
      </Col>
    </Fragment>
  );
};

export default ListNewContact;